document.addEventListener("DOMContentLoaded", function () {
  // store modals
  const modals = {};

  // create modals
  Array.from(document.getElementsByClassName("ac-modal")).forEach((modalElement) => {
    // modal
    const modal = modalElement

    // store in dictionary
    const modalId = modalElement.getAttribute("id");
    modals[modalId] = modal;
  });

  // open modal
  Array.from(document.querySelectorAll(".ac-modal-trigger[data-ajax-url], .ac-modal-trigger[data-modal-target]")).forEach((trigger) => {
    const targetModalId = trigger.getAttribute("data-modal-target");
    const modal = modals[targetModalId];
    if (modal) {
      // open corresponding modal
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        onModalTriggerClick(trigger, modal);
      });
      onModalClose(trigger, modal);
    }
  });
});

async function onModalTriggerClick(trigger, modal) {
  if (!trigger || !modal) return;
  if (trigger.dataset.ajaxLoaded) return;

  const ajaxUrl       = trigger.getAttribute('data-ajax-url') || '';
  const ajaxIframe    = trigger.getAttribute('data-ajax-iframe') === 'true';
  const customCompare = trigger.getAttribute('data-custom-compare') === 'true';
  const txtUrl        = trigger.getAttribute('data-txt-url') || '';
  const txtPlain      = trigger.getAttribute('data-txt-plain') || 'false';

  // Prioritize txtUrl whenever it's present; otherwise fall back to ajaxUrl
  const contentUrl = txtUrl || ajaxUrl;
  const isFullPageFallback = !txtUrl && ajaxUrl;

  console.log('Modal trigger data:', {
    ajaxUrl,
    ajaxIframe,
    txtUrl,
    contentUrl,
    txtPlain
  });

  if (!contentUrl) {
    console.warn('No contentUrl (missing data-ajax-url and data-txt-url) on trigger:', trigger);
    return;
  }

  toggleLoadingState(modal, true);

  let html;

  try {
    const response = await fetch(contentUrl);
    if (!response.ok) {
      throw new Error('Failed to load content: ' + response.status);
    }

    let txt = await response.text();

    if (txtPlain === 'true') {
      // treat as text -> basic HTML
      html = txt
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/\r\n|\r|\n/g, '<br>');
    } else {
      // When falling back to full page URL, extract only main content (no header/footer)
      if (isFullPageFallback) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(txt, 'text/html');
        const mainContent = doc.getElementById('MainContent');
        if (mainContent && mainContent.innerHTML) {
          // Parse the main content and remove title bar elements (page name, modal headline)
          const contentDoc = parser.parseFromString(mainContent.innerHTML.trim(), 'text/html');
          const body = contentDoc.body;

          contentDoc.getElementById('modal-headline')?.remove();
          body.querySelectorAll('#modal-headline, .main-page-title, .page-title, h1.visually-hidden').forEach((el) => el.remove());

          // Remove first h1 if present (theme often puts page title as first element in main)
          const firstH1 = body.querySelector('h1');
          if (firstH1) {
            const parent = firstH1.parentElement;
            firstH1.remove();
            if (parent && parent !== body && !parent.textContent.trim()) parent.remove();
          }

          // If first element is main-page section (title + .rte), replace it with only the .rte content to remove title bar wrapper/padding
          const mainPageSection = body.querySelector('.apl-section-main-page, .shopify-section.apl-section-main-page');
          if (mainPageSection) {
            const rte = mainPageSection.querySelector('.rte');
            if (rte) {
              mainPageSection.replaceWith(rte.cloneNode(true));
            }
          }

          // Remove any first child that is empty (leftover title bar wrapper)
          let first = body.firstElementChild;
          while (first && first !== body && !first.textContent.trim()) {
            const next = first.nextElementSibling;
            first.remove();
            first = next;
          }

          html = body.innerHTML.trim();
        } else {
          html = txt;
        }
      } else {
        html = txt;
      }
    }
  } catch (error) {
    console.error('Error in onModalTriggerClick fetch:', error);
    toggleLoadingState(modal, false);
    return;
  }

  if (!html) {
    toggleLoadingState(modal, false);
    return;
  }

  if (ajaxIframe) {
    let iframe = modal.querySelector('iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';
      modal.appendChild(iframe);
    }

    if (typeof openLinkInNewTab === 'function') {
      openLinkInNewTab(iframe);
    }

    iframe.srcdoc = html;
  } else {
    const template = SDG?.Data?.template || '';

    modal.innerHTML = html;

    // MOXIE: mac-center.com tiene CSP frame-ancestors:'none' — bloquea que la tienda
    // se embeba en cualquier iframe, incluyendo iframes dentro del propio contenido cargado.
    // Convertir iframes same-origin a contenedores AJAX para evitar el bloqueo.
    modal.querySelectorAll('iframe[src]').forEach(function(iframe) {
      var src = iframe.getAttribute('src') || '';
      if (!src || src === 'about:blank') return;
      try {
        var iframeUrl = new URL(src, window.location.origin);
        if (iframeUrl.origin === window.location.origin) {
          var wrapper = document.createElement('div');
          wrapper.className = 'ac-ajax-iframe-wrapper';
          wrapper.style.cssText = 'width:100%;overflow:auto;';
          iframe.replaceWith(wrapper);
          fetch(iframeUrl.href)
            .then(function(r) { return r.text(); })
            .then(function(iframeHtml) {
              var p = new DOMParser();
              var d = p.parseFromString(iframeHtml, 'text/html');
              var main = d.getElementById('MainContent');
              wrapper.innerHTML = main ? main.innerHTML : iframeHtml;
              executeScripts(wrapper);
            })
            .catch(function() {});
        }
      } catch (e) {}
    });

    // MOXIE: inline !important via setProperty — máxima prioridad posible.
    // Los <style> de Apple se inyectan dentro del modal y siempre cargan DESPUÉS
    // de cualquier stylesheet externo. setProperty('important') crea estilos inline
    // !important que ningún stylesheet puede sobreescribir, independientemente
    // del orden de carga o especificidad.
    requestAnimationFrame(() => {
      if (window.innerWidth > 768) return;

      // Overlay: ancho completo, sin márgenes
      const overlay =
        modal.closest('.modal-overlay') ||
        document.querySelector('.modal-open .modal-overlay') ||
        document.querySelector('.modal-page-overlay .modal-overlay');
      if (overlay) {
        overlay.style.setProperty('width', '100vw', 'important');
        overlay.style.setProperty('max-width', '100vw', 'important');
        overlay.style.setProperty('margin-left', '0', 'important');
        overlay.style.setProperty('margin-right', '0', 'important');
        overlay.style.setProperty('border-radius', '0', 'important');
        overlay.style.setProperty('min-height', '100dvh', 'important');
      }

      // Content container: elimina padding lateral de 76px de Apple
      const cc =
        modal.closest('.modal-content-container') ||
        document.querySelector('.modal-open .modal-content-container') ||
        document.querySelector('.modal-page-overlay .modal-content-container');
      if (cc) {
        cc.style.setProperty('padding-inline-start', '0', 'important');
        cc.style.setProperty('padding-inline-end', '0', 'important');
        cc.style.setProperty('overflow-x', 'hidden', 'important');
        cc.style.setProperty('max-width', '100%', 'important');
        cc.style.setProperty('box-sizing', 'border-box', 'important');
      }

      // .section-content: Apple lo fija en 980px via <style> embebido
      modal.querySelectorAll('.section-content').forEach(el => {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });

      // .section: evitar desbordamiento horizontal
      modal.querySelectorAll('.section').forEach(el => {
        el.style.setProperty('overflow-x', 'hidden', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });

      // Columnas del grid: apilar verticalmente en móvil
      modal.querySelectorAll('.section-content .column').forEach(el => {
        el.style.setProperty('flex-basis', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });

      // Bento boxes (tarjetas del popup de features)
      modal.querySelectorAll('.bento-box, .bentobox-item').forEach(el => {
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });

      // Tabla de comparación: scroll horizontal interno
      modal.querySelectorAll('.section-compare-table, .compare-wrapper').forEach(el => {
        el.style.setProperty('overflow-x', 'auto', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      });
    });

    // Re-execute all script tags (scripts don't execute when using innerHTML)
    executeScripts(modal);

    // Special handling for compare modals (collection.plp or any page with customCompare)
    if (customCompare && modal) {
      setTimeout(() => {
        const $scripts = modal.querySelectorAll('script') || [];

        if ($scripts.length > 0) {
          $scripts.forEach(script => {
            if (script.textContent.includes('channelCompare')) {
              let scriptContent = script.textContent.replace(/const reorderDOM/g, 'var reorderDOM');
              const $compareHeader = modal.querySelectorAll('#interactive-compare-header');
              const newScript = document.createElement('script');
              newScript.textContent = scriptContent;
              modal.appendChild(newScript);

              if ($compareHeader && typeof channelCompare !== 'undefined' && channelCompare?.init) {
                channelCompare.init();
              }
            }
          });
        }
      }, 500);
    }
  }

  trigger.dataset.ajaxLoaded = 'true';
  toggleLoadingState(modal, false);
}



/**
 * Re-execute script tags in an element
 * Scripts don't execute when using innerHTML, so we need to extract and re-inject them
 * @param {Node} element - The element containing scripts to re-execute
 */
function executeScripts(element) {
  if (!element) return;

  const scripts = element.querySelectorAll('script');
  if (!scripts || scripts.length === 0) return;

  scripts.forEach((oldScript) => {
    const newScript = document.createElement('script');
    
    // Copy all attributes from the old script
    Array.from(oldScript.attributes).forEach((attribute) => {
      newScript.setAttribute(attribute.name, attribute.value);
    });
    
    // Copy the script content (for inline scripts)
    if (oldScript.textContent) {
      newScript.appendChild(document.createTextNode(oldScript.textContent));
    }
    
    // Replace the old script with the new one (this triggers execution)
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

function openLinkInNewTab(iframe) {
  // Stores the compare page path to distinguish it from product page navigations
  var comparePagePath = null;

  function setupHandlers(iframeDocument) {
    // Set target on all existing static links
    var links = iframeDocument.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].getAttribute('target')) {
        links[i].setAttribute('target', '_parent');
      }
      links[i].addEventListener('click', function (event) {
        event.preventDefault();
        var href = this.getAttribute('href');
        if (href && href !== '#') {
          window.open(href, '_parent');
        }
      });
    }

    // Event delegation for dynamically added links with real hrefs
    iframeDocument.addEventListener('click', function (event) {
      var target = event.target.closest('a');
      if (!target) return;
      var href = target.getAttribute('href');
      if (href && href !== '#' && !href.startsWith('javascript:')) {
        event.preventDefault();
        window.open(href, '_parent');
      }
    }, true);
  }

  function handleIframeLoad() {
    var iframeWindow = iframe.contentWindow;
    var currentUrl = '';

    try {
      currentUrl = iframeWindow.location.href;
    } catch (e) {}

    // Skip blank/empty loads
    if (!currentUrl || currentUrl === 'about:blank' || currentUrl.startsWith('about:')) return;

    // Normalize URL: strip query string and hash for comparison
    var currentPath = currentUrl.split('?')[0].split('#')[0];

    // First load or re-open of the same compare page → set up handlers
    if (!comparePagePath || currentPath === comparePagePath) {
      comparePagePath = currentPath;
      setupHandlers(iframeWindow.document);
      setTimeout(() => {
        window.adobeTrackMarketingPageIframeCtaClick(iframe);
        window.adobeTrackMarketingPageIframeScroll(iframe);
      }, 10);
      return;
    }

    // Different URL = widget navigated to a product page via "Comprar" → redirect parent
    window.open(currentUrl, '_parent');
  }

  iframe.onload = handleIframeLoad;
}

/**
 * toggle loading state for modal
 * @param {Node} $modal
 * @param {Boolean} isLoading
 */
function toggleLoadingState($modal, isLoading) {
  const $modalSpinner = $modal.querySelector('.ac-progress-indicator');
  const $modalSpinnerParent = $modalSpinner?.parentNode;
  if (isLoading) {
    $modal.classList.add('is-loading');
  } else {
    $modal.classList.remove('is-loading');
    if ($modalSpinnerParent) $modal.removeChild($modalSpinnerParent);
  }
}

/**
 * on modal close
 * @param  {Node} $trigger trigger element
 * @param  {Node} $modal modal element
 */
function onModalClose($trigger, $modal) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        window.pauseAllMedia();
        if(mutation.attributeName == 'class'){
            const isOpen = mutation.target.classList.contains('modal-open');
            // clear modal content if modal is closed
            if (!isOpen) {
              const { ajaxUrl } = $trigger.dataset;
              if (ajaxUrl) {
                setTimeout(() => {
                  const $modalContent = mutation.target.querySelector('.ac-modal');
                  $modalContent.innerHTML = `
                    <div class="seedkit-component-standalone">
                      <div class="ac-progress-indicator">
                        <div data-progress-indicator="" class="progress-indicator progress-indicator-indeterminate progress-indicator-immediate progress-indicator-curtain progress-indicator-visible">
                          <svg class="progress-indicator-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" aria-hidden="true">
                              <g class="progress-indicator-spokes">
                                  <path class="progress-indicator-spoke" d="M28,8.5A2.5,2.5,0,0,1,30.5,11v7a2.5,2.5,0,0,1-5,0V11A2.5,2.5,0,0,1,28,8.5Z"></path>
                                  <path class="progress-indicator-spoke" d="M41.79,14.21a2.52,2.52,0,0,1,0,3.54L36.84,22.7a2.5,2.5,0,0,1-3.54-3.54l5-4.95A2.52,2.52,0,0,1,41.79,14.21Z"></path>
                                  <path class="progress-indicator-spoke" d="M47.5,28A2.5,2.5,0,0,1,45,30.5H38a2.5,2.5,0,0,1,0-5h7A2.5,2.5,0,0,1,47.5,28Z"></path>
                                  <path class="progress-indicator-spoke" d="M41.79,41.79a2.52,2.52,0,0,1-3.54,0l-5-4.95a2.5,2.5,0,0,1,3.54-3.54l4.95,5A2.52,2.52,0,0,1,41.79,41.79Z"></path>
                                  <path class="progress-indicator-spoke" d="M28,47.5A2.5,2.5,0,0,1,25.5,45V38a2.5,2.5,0,0,1,5,0v7A2.5,2.5,0,0,1,28,47.5Z"></path>
                                  <path class="progress-indicator-spoke" d="M14.21,41.79a2.52,2.52,0,0,1,0-3.54l4.95-5a2.5,2.5,0,0,1,3.54,3.54l-4.95,4.95A2.52,2.52,0,0,1,14.21,41.79Z"></path>
                                  <path class="progress-indicator-spoke" d="M8.5,28A2.5,2.5,0,0,1,11,25.5h7a2.5,2.5,0,0,1,0,5H11A2.5,2.5,0,0,1,8.5,28Z"></path>
                                  <path class="progress-indicator-spoke" d="M14.21,14.21a2.52,2.52,0,0,1,3.54,0l4.95,4.95a2.5,2.5,0,0,1-3.54,3.54l-4.95-4.95A2.52,2.52,0,0,1,14.21,14.21Z"></path>
                              </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  `;
                  $trigger.removeAttribute('data-ajax-loaded');
                }, 500);
              } else {
                // stop video if modal is closed
                const $video = mutation.target.querySelector('video');
                if ($video) {
                  $video.pause();
                  $video.currentTime = 0;
                }
              }
            }
        }
    });
  });
  const $modalRoot = $modal.closest('.modal');
  if (!$modalRoot) return;
  observer.observe($modalRoot, {attributes: true});
}
